import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { getInitialScheduleValue } from 'reducks/schedule/selectors'
import { ScheduleType } from 'types/schedule'
import { FirebaseDocRefType } from 'firebase/index'

const useInitSchedulesByType = (
  breadRef: FirebaseDocRefType,
  storeRef: FirebaseDocRefType,
  getUpdateSchedulesFunction: (
    type: StockUnionType,
    setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
    setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
  ) => Dispatch<SetStateAction<ScheduleType[]>> | undefined,
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setIsTypeDaily: Dispatch<SetStateAction<boolean>>,
  setIsTypePreorder: Dispatch<SetStateAction<boolean>>,
  setIsTypeShared: Dispatch<SetStateAction<boolean>>,
  setIsTypeDelivery: Dispatch<SetStateAction<boolean>>
): ((type: StockUnionType) => void) => {
  return useCallback(
    (type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      const initialValue = getInitialScheduleValue(breadRef, storeRef.collection('store_schedules').doc(), type)
      update([...[initialValue]])
      switch (type) {
        case 'daily':
          setIsTypeDaily(false)
          break
        case 'preorder':
          setIsTypePreorder(false)
          break
        case 'shared':
          setIsTypeShared(false)
          break
        default:
          break
      }
    },
    [
      breadRef,
      storeRef,
      getUpdateSchedulesFunction,
      setDailySchedules,
      setPreorderSchedules,
      setIsTypeDaily,
      setIsTypePreorder,
      setIsTypeShared,
      setIsTypeDelivery,
    ]
  )
}

export default useInitSchedulesByType
